





























































































































































































































import * as _ from "lodash";
import {
  AccomodationUnitTypeLOSCategory,
  AccomodationUnitTypeViewModel,
} from "@/shared/models/accomodationUnitTypeViewModel";
import {
  Component,
  Prop,
  PropSync,
  Ref,
  Vue,
  Watch,
} from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { LanguageView } from "@/shared/models/languages";
import { ListModel } from "@/shared/models/listModel";
import { Notification } from "@/store/modules/notifications";
import { LOSCategoryTemplateModel } from "@/shared/models/losCategoryTemplate";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import handleBrokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";
import { Currency } from "@/shared/models/currency";
import { AxiosResponse } from "axios";

@Component({
  components: {
    NumericInputImproved,
    RightDrawer,
    SortableHeadersTable,
  },
})
export default class AccomodationUnitTypeLOSCategoriesForm extends Vue {
  @PropSync("open") internalOpen?: boolean;
  @Prop() unitType?: AccomodationUnitTypeViewModel;
  @Prop() existingCategories?: AccomodationUnitTypeLOSCategory[];
  @PropSync("categoryId", { default: null }) internalCategoryId?: number | null;

  fkey = 0;
  isFormValid = false;
  submitting = false;
  loading = false;

  model = [] as AccomodationUnitTypeLOSCategory[];
  initialModel = [] as AccomodationUnitTypeLOSCategory[];

  selectedTemplate: LOSCategoryTemplateModel | null = null;
  templateList: LOSCategoryTemplateModel[] = [];

  loadLOSCategoryTemplates() {
    this.axios
      .get<ListModel<LOSCategoryTemplateModel>>("/LOSCategoryTemplates")
      .then((res) => {
        this.templateList = res.data.result;
      });
  }

  selectTemplate() {
    if (this.selectedTemplate) {
      this.model = this.selectedTemplate.losCategoryTemplateItems.map((x) => {
        return {
          id: 0,
          accomodationUnitTypeId: this.unitType?.id ?? 0,
          isDefault: false,
          minStay: x.minStay,
          maxStay: x.maxStay,
          inputPriceDifference: x.inputPriceDifference,
          inputPriceDifferenceIsAbsolute: x.inputPriceDifferenceIsAbsolute,
          outputPriceDifference: x.outputPriceDifference,
          outputPriceDifferenceIsAbsolute: x.outputPriceDifference,
        } as AccomodationUnitTypeLOSCategory;
      });
    } else {
      this.model = [new AccomodationUnitTypeLOSCategory(this.unitType?.id)];
    }
  }

  @Watch("internalOpen")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;
    }

    if (fresh && this.internalCategoryId) {
      this.load();
    } else {
      this.model = [new AccomodationUnitTypeLOSCategory(this.unitType?.id)];
      this.model[0].isDefault = this.noDefaultCategory;
      this.initialModel = _.cloneDeep(this.model);
    }

    if (!fresh) {
      this.internalCategoryId = null;
    }
  }

  load() {
    this.loading = true;
    this.axios
      .get<AccomodationUnitTypeLOSCategory>(
        `/AccomodationUnitTypes/${this.unitType?.id}/losCategories/${this.internalCategoryId}`
      )
      .then((res) => {
        this.model = [res.data];
        this.initialModel = _.cloneDeep(this.model);
      })
      .finally(() => (this.loading = false));
  }

  @Ref("form") formRef?: {
    resetValidation: () => void;
    validate: () => boolean;
  };

  @Getter("appParams/tenantUsesInputPrice") tenantUsesInputPrice?: boolean;
  @Getter("appParams/workingCurrency") workingCurrency?: Currency;

  @Getter("language/language") language?: string;
  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  @Action("codebooks/refreshLanguages") refreshLanguages?: () => Promise<void>;
  @Getter("codebooks/languages") languages?: LanguageView[];

  async created() {
    const promises = [];

    if ((this.languages?.length ?? 0) === 0 && this.refreshLanguages) {
      promises.push(this.refreshLanguages());
    }

    await Promise.all(promises);
  }

  mounted() {
    this.loadLOSCategoryTemplates();
  }

  get showPriceDiffNote() {
    return this.model.some((e) => !e.isDefault);
  }

  get noDefaultCategory() {
    return (
      (this.existingCategories?.filter((x) => x.isDefault).length ?? 0) < 1
    );
  }

  addCategory() {
    this.model.push(new AccomodationUnitTypeLOSCategory(this.unitType?.id));
  }

  removeCategory(item: AccomodationUnitTypeLOSCategory) {
    const index = this.model.findIndex((x) => x == item);
    if (index != -1) {
      this.model.splice(index, 1);
    }
  }

  defaultChanged(index: number) {
    if (this.model[index].isDefault) {
      this.model.forEach((x, i) => {
        if (i !== index) x.isDefault = false;
      });
    }
  }

  get priceDifferenceItems() {
    return [
      {
        text: this.$t("OB.LOS.Category.IsPriceDifferenceAbsolute"),
        value: true,
      },
      {
        text: this.$t("OB.LOS.Category.IsPriceDifferencePercentage"),
        value: false,
      },
    ];
    }

  submit(overrides: string[] = []) {
    if (this.submitting) return;
      this.submitting = true;
      this.formRef?.validate();
    if (!this.isFormValid) {
      this.submitting = false; 
        return;
    }

    const handleCodes = [
      "AccomodationUnitType.LOSCategories.DefaultAlreadyExists",
    ];
      const adapter = handleBrokenRuleAdapter(this.axios, handleCodes);

      const isOverriding = overrides.length !== 0;
    // prettier-ignore
    const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

    const confirmOverrideNotification = (
      x: AxiosResponse & { handled: string[] }
    ) =>
      this.$store.dispatch("showNotification", {
        color: "warning",
          message:
              // prettier-ignore
              `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
        timeout: 30000,
        actions: [
          {
            text: this.$t("Yes"),
            fun: () => {
              this.submit(x.handled);
              return true;
            },
          },
          { text: this.$t("Cancel"), fun: () => true },
        ],
      } as Notification);

    const handleSuccess = () => {
      this.$store.dispatch("showNotification", {
        color: "success",
        message: this.$t("UnitTypeLOSCategory.SaveSuccess"),
        timeout: 5000,
      } as Notification);
      this.internalOpen = false;
      this.$emit("saved");
    };

    // update 
    if (this.internalCategoryId) {
      const request = {
        overrideRules: overrides,
        ...this.model[0],
      };

      this.axios
        .put(
          `/AccomodationUnitTypes/${this.unitType?.id}/losCategories/${request.id}`,
          request,
          {
            adapter: isOverriding ? undefined : adapter,
          }
        )
        .then(() => handleSuccess())
        .catch((x) => {
          if (x && x.isHandleBrokenRuleResult && !isOverriding) {
            confirmOverrideNotification(x);
          } else {
            this.$store.dispatch("showNotification", {
              color: "error",
              message: `${formatBrokenRuleNames(x.unhandled)}`,
              timeout: 5000,
            } as Notification);
          }
        })
        .finally(() => (this.submitting = false));
    }
    // create
    else {
      this.axios
        .post(
          `/AccomodationUnitTypes/${this.unitType?.id}/losCategories`,
          {
            overrideRules: overrides,
            items: this.model,
          },
          {
            adapter: isOverriding ? undefined : adapter,
          }
        )
        .then(() => handleSuccess())
        .catch((x) => {
          if (x && x.isHandleBrokenRuleResult && !isOverriding) {
            confirmOverrideNotification(x);
          } else {
            this.$store.dispatch("showNotification", {
              color: "error",
              message: `${formatBrokenRuleNames(x.unhandled)}`,
              timeout: 5000,
            } as Notification);
          }
        })
        .finally(() => (this.submitting = false));
    }
  }

  get isSaveDisabled(){
    return !this.isFormValid || this.submitting;
  }

  // validation
  get rules() {
    return {
      required: (value: any) =>
        !!value || value === 0 || this.$t("Validation.Required"),
      oneOrPositive: (value: number) =>
        value >= 1 || this.$t("Validation.MustBeOneOrPositive"),
      zeroOrPositive: (value: any) =>
        +value >= 0 || this.$t("Validation.MustBeZeroOrPositive"),
      minLowerThanMax: (min: number | null, max: number | null) =>
        min === null ||
        max === null ||
        min <= max ||
        max === 0 || // 0 == infinite
        this.$t(
          "AccomodationUnitType.LOSCategories.MinStaysGreaterThanMaxStays"
        ),
      greaterThanMinus100: (value: number | null, priceDifferenceIsAbsolute: boolean | null) =>
        value === null ||
        value === undefined || 
        value > -100 ||
        priceDifferenceIsAbsolute ||
        this.$t("Validation.MinValue"),
    };
  }

  requiredIfPriceEntered(num: number, val: boolean) {
    if (num && (val === undefined || val === null)) {
      return this.$t("Validation.RequiredIfPriceEntered");
    } else {
      return true;
    }
  }

  requiredIfDifferenceTypeEntered(num: number, val: boolean) {
    if (
      val !== undefined &&
      val !== null &&
      (num === null || num === undefined)
    ) {
      return this.$t("Validation.Required");
    } else {
      return true;
    }
  }
}
